import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { DeskPageRoutingModule } from "./desk-routing.module";

import { DeskPage } from "./desk.page";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SpaceListModule } from "../_component/_space/space-list/space-list.module";
import { SpaceViewModule } from "../_component/_space/space-view/space-view.module";
import { SpaceReservationsComponentModule } from "../_component/_space/space-reservations/space-reservations.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DeskPageRoutingModule,
    HeaderModule,
    SpaceListModule,
    SpaceViewModule,
    SpaceReservationsComponentModule,
  ],
  declarations: [DeskPage],
})
export class DeskPageModule {}
